import { Config, extendTailwindMerge } from 'tailwind-merge';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const customTailwindTheme = resolveConfig(tailwindConfig).theme;

const getToken = (tokenName: Exclude<keyof typeof customTailwindTheme, 'extend'>, prrefix?: string) =>
  Object.keys(customTailwindTheme[tokenName])
    .filter(key => key !== 'DEFAULT')
    .map(key => `${prrefix ?? ''}${key}`);

const tailwindMergeConfig = {
  classNames: {
    'dynamic-gap': 'var(--dynamic-gap)',
  },
  theme: {
    colors: getToken('colors'),
    spacing: getToken('spacing'),
    borderRadius: getToken('borderRadius'),
    borderWidth: getToken('borderWidth'),
  },
  extend: {
    classGroups: {
      'font-size': [{ text: getToken('fontSize') }],
    },
  },
};

export function tm(...inputs: string[]) {
  return extendTailwindMerge(tailwindMergeConfig as unknown as Config<string, string>)(inputs);
}
